import * as React from "react"
import { Decoration } from "react-diff-view"
import { Symbols } from "@tenforce/toolbox-fontmap"
import bem from "../../bem"

import "./Unfold.scss"

const b = bem.with("NewUI__packageImport__unfold")

interface Props {
    start: number
    end: number
    direction: string
    onExpand: (start: number, end: number) => void
}

const ICON_TYPE_MAPPING: Record<string, string> = {
    none: Symbols.Expand,
    up: Symbols.ExpandedBelow,
    down: Symbols.ExpandedAbove,
}

export default class Unfold extends React.Component<Props> {
    render(): JSX.Element {
        const { start, end, direction } = this.props
        const icon = ICON_TYPE_MAPPING[direction]
        const lines = end - start

        return (
            <Decoration>
                <div className={b("root")} onClick={this.expand}>
                    <span className={b("icon")}>{icon}</span>
                    &nbsp;{lines} lines
                </div>
            </Decoration>
        )
    }

    expand = (): void => {
        const { start, end, onExpand } = this.props
        onExpand(start, end)
    }
}
